import { staticPath } from "mypage/src/lib/$path";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { CircularProgress } from "~/components/atoms/CircularProgress";
import * as AtomsImage from "~/components/atoms/Image";
import { getCloudflareFullImageUrl } from "~/lib/cloudflare";
import { colorBlack, colorPrimary } from "~/lib/constants";
import { unstyledButton } from "~/styles/CommonStyles";

interface Props {
  imageSrc: string;
  isResizing?: boolean;
  onClickSize: (size?: number) => void;
  onClickComment: () => void;
}

const sizeList = [480, 400, 320, 256, 192, 128, 64];

const CommentAndResize: React.VFC<Props> = ({
  imageSrc,
  isResizing,
  onClickComment,
  onClickSize,
}) => {
  const [originalSize, setOriginalSize] = useState<number>();
  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setOriginalSize(img.naturalWidth);
    };
    img.src = getCloudflareFullImageUrl(imageSrc);
  }, [imageSrc]);

  return (
    <Container>
      <CommentButton
        type="button"
        onClick={onClickComment}
        onTouchEnd={onClickComment}
      >
        <AtomsImage.default
          src={staticPath.img.icon_comment_white_svg}
          alt="icon comment"
          height={28}
          width={28}
          disableHover
        />
        <span>コメントする</span>
      </CommentButton>
      <Title>画像のサイズを変更</Title>
      <SizeButtonWrap>
        <SizeButton
          onTouchEnd={() => onClickSize()}
          onClick={() => onClickSize()}
        >
          オリジナル
        </SizeButton>
        {sizeList.map((size) => (
          <SizeButton
            onTouchEnd={() => onClickSize(size)}
            onClick={() => onClickSize(size)}
            key={size}
          >
            {size}px
          </SizeButton>
        ))}
      </SizeButtonWrap>
      <Explanation>
        オリジナルの画像サイズ： {originalSize ? `${originalSize}px` : "..."}
      </Explanation>
      {isResizing && (
        <LoadingMask>
          <CircularProgress />
        </LoadingMask>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: grid;
  position: relative;
`;

const LoadingMask = styled.div`
  align-items: center;
  background-color: rgba(255, 255, 255, 0.3);
  display: grid;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

const CommentButton = styled.button`
  ${unstyledButton}

  align-items: center;
  background-color: ${colorPrimary[500]};
  border-radius: 8px;
  border: 1px solid ${colorPrimary[500]};
  color: #fff;
  display: flex;
  font-size: 20px;
  font-weight: bold;
  grid-column-gap: 12px;
  height: 60px;
  justify-content: center;
  line-height: 34px;

  &:hover {
    background-color: ${colorPrimary[600]};
  }
`;

const Title = styled.div`
  color: ${colorBlack[600]};
  font-weight: 700;
  font-size: 16px;
  line-height: 30px;
  margin-top: 24px;
`;

const Explanation = styled(Title)`
  color: ${colorBlack[400]};
  margin-top: 16px;
`;

const SizeButtonWrap = styled.div`
  display: flex;
  gap: 16px 8px;
  flex-wrap: wrap;
  margin-top: 16px;
  width: 328px;
  max-width: 100%;
`;

const SizeButton = styled.div`
  border: 1px solid ${colorPrimary[500]};
  border-radius: 5px;
  color: ${colorPrimary[500]};
  cursor: pointer;
  font-weight: 700;
  padding: 3px 8px;

  &:hover {
    background-color: ${colorPrimary[50]};
  }
`;

export default CommentAndResize;
